import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { selectors as uiSelectors, actions as uiActions } from 'builder/modules/ui'
import AiCoach from 'builder/features/conversationalBuilder/assets/AiCoach'
import { selectors } from 'builder/modules/resumeEditor'
import { FloatingButtonComponent } from './styles'

export const AiWriterButton = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { features } = useFeaturesConfig()
  const isConversationalBuilderOpen = useTypedSelector(uiSelectors.isConversationalBuilderOpen)
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const handleToggleConversationalBuilder = () => {
    if (!isConversationalBuilderOpen) {
      trackInternalEvent('chat_open', { label: 'builder' })
    }
    dispatch(uiActions.toggleConversationalBuilder(!isConversationalBuilderOpen))
  }

  if (!features.resumeBuilderAiCopilot || autoTailoringFromPublicJobBoard.enabled) {
    return null
  }

  return (
    <FloatingButtonComponent
      $aiWriterOpen={isConversationalBuilderOpen}
      onClick={handleToggleConversationalBuilder}
    >
      <AiCoach />
      {i18n.t('builder.conversational_builder.ask_ai_writer')}
    </FloatingButtonComponent>
  )
}
